import React, { useEffect } from 'react';
// import TagManager from 'react-gtm-module';
import RegisterHero from '../components/RegisterHero';
import Designers from '../components/Designerss';
import YourBenefits from '../components/YourBenefits';
import FAQ from '../components/FAQ';

const Register = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (

    <>
      <RegisterHero />
      <YourBenefits />
      <Designers titleVisible={true} />
      <FAQ />
    </>
  )
};

// TagManager.dataLayer({
//   dataLayer: {
//       event: 'event_RegisterFormDisplayed'
//   }
// });

export default Register